// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingIndicator-styles-module--container--1p8aU","spinner":"LoadingIndicator-styles-module--spinner--Bg7qq"};